import { createSlice } from "@reduxjs/toolkit";
import { downloadFile, uploadFile, fetchFiles } from "./DownloadFiles.thunk";

const baseState = {
  status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  downloadStatus: "idle", // Status for individual file downloads
  uploadStatus: "idle", // Status for file uploads
  error: null,
  files: [], // Array of file objects: { id, name, type, size, createdAt }
};

const initialState = {
  ...baseState,
};

export const downloadFilesSlice = createSlice({
  name: "downloadFiles",
  initialState,
  reducers: {
    // Reset actions
    ResetStore: (state) => {
      return { ...baseState };
    },
    // Reset download status
    ResetDownloadStatus: (state) => {
      state.downloadStatus = "idle";
    },
    // Reset upload status
    ResetUploadStatus: (state) => {
      state.uploadStatus = "idle";
    },
  },
  extraReducers: (builder) => {
    // Fetch files
    builder
      .addCase(fetchFiles.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchFiles.fulfilled, (state, action) => {
        state.files = action.payload || [];
        state.status = "succeeded";
        state.error = null;
      })
      .addCase(fetchFiles.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || "Error fetching files";
      });

    // Download file
    builder
      .addCase(downloadFile.pending, (state) => {
        state.downloadStatus = "loading";
        state.error = null;
      })
      .addCase(downloadFile.fulfilled, (state) => {
        state.downloadStatus = "succeeded";
        state.error = null;
      })
      .addCase(downloadFile.rejected, (state, action) => {
        state.downloadStatus = "failed";
        state.error = action.payload?.message || "Error downloading file";
      });

    // Upload file
    builder
      .addCase(uploadFile.pending, (state) => {
        state.uploadStatus = "loading";
        state.error = null;
      })
      .addCase(uploadFile.fulfilled, (state, action) => {
        // Add the new file to the list
        if (action.payload) {
          state.files = [...state.files, action.payload];
        }
        state.uploadStatus = "succeeded";
        state.error = null;
      })
      .addCase(uploadFile.rejected, (state, action) => {
        state.uploadStatus = "failed";
        state.error = action.payload?.message || "Error uploading file";
      });
  },
});

export const { ResetStore, ResetDownloadStatus, ResetUploadStatus } =
  downloadFilesSlice.actions;

export default downloadFilesSlice.reducer;
